// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"61f12bb7","977":"a976ade4"}[chunkId] + ".chunk.js";
};